import React from "react";
import { HeaderTheme } from "./HeaderTheme";
import { SanityNode } from "../../config/build/models/node";
import SanityLink from "../SanityLink";

interface Props {
    icon: string;
    title: string;
    description?: string;
    linkReference?: SanityNode;
    color?: string;
}

const theme = {
    [HeaderTheme.Primary]: {
        background: "bg-brand-primary-95",
        text: "text-navigation-link",
        hoverBackground: "bg-brand-primary-95-dark",
        hoverText: "hover:text-navigation-link-hover"
    },
    [HeaderTheme.Secondary]: {
        background: "bg-brand-secondary-90",
        text: "text-navigation-link",
        hoverBackground: "bg-brand-secondary-90-dark",
        hoverText: "hover:text-navigation-link-hover"
    }
};

const IconTeaser = (props: Props) => {
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const svgIcon = require(`../../assets/images/${props.icon}.svg`);

    const currentTheme = theme[props.color ?? HeaderTheme.Primary];

    return (
        <SanityLink 
            reference={props.linkReference} 
            className={`
                group flex items-center mb-8 no-underline text-navigation-link ${currentTheme.text} ${currentTheme.hoverText} focus:outline-none focus:shadow-outline
                xl:mb-0
            `}
        >
            <div className={`flex flex-shrink-0 justify-center items-center w-16 h-16 text-navigation-icon ${currentTheme.background} rounded-full transition duration-300`}>
                <svg width={32} height={32} className="fill-current">
                    <use xlinkHref={svgIcon.url}/>
                </svg>
            </div>
            <div className="flex flex-col pl-4">
                <p className="my-0 uppercase font-bold text-base text-current">{props.title}</p>
                
                {props.description &&
                    <small className="text-base">{props.description}</small>
                }
            </div>
        </SanityLink>
    );
};

export default IconTeaser;